import type { FC, SVGProps } from 'react';

export const ProfileCardIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="14"
      height="14"
      fill="currentColor"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2002_5758)">
        <rect width="14" height="14" fillOpacity="0.01" fill="currentColor" />
        <g clipPath="url(#clip1_2002_5758)">
          <path
            fill="currentColor"
            d="M13.4996 1.49707C13.7761 1.49707 13.9995 1.72062 13.9996 1.99707V11.9971C13.9996 12.2736 13.7762 12.4971 13.4996 12.4971H0.499634C0.223239 12.4969 -0.000366211 12.2735 -0.000366211 11.9971V1.99707C-0.000232348 1.72074 0.223322 1.49727 0.499634 1.49707H13.4996ZM1.12463 2.62207V11.3721H12.8746V2.62207H1.12463ZM4.82971 4.48145C5.79055 4.48146 6.56981 5.26438 6.56995 6.23145C6.57099 6.66754 6.40924 7.0885 6.11584 7.41113C6.78144 7.82364 7.23713 8.54904 7.28088 9.38184C7.28171 9.39873 7.27993 9.41578 7.27405 9.43164C7.26815 9.44753 7.25839 9.46234 7.2467 9.47461C7.2351 9.4867 7.2211 9.49632 7.20569 9.50293C7.1901 9.5096 7.17284 9.51272 7.15588 9.5127H6.47034C6.40471 9.5127 6.35198 9.46113 6.34729 9.39551C6.28781 8.60655 5.62769 7.98145 4.82776 7.98145C4.028 7.98163 3.36868 8.60668 3.3092 9.39551C3.30452 9.46106 3.25168 9.51258 3.18616 9.5127H2.49963C2.42797 9.5125 2.37236 9.45354 2.37854 9.38184C2.39942 8.98373 2.51638 8.59603 2.71936 8.25293C2.92232 7.91005 3.20489 7.62101 3.54358 7.41113C3.26089 7.09866 3.08948 6.68603 3.08948 6.23145C3.08961 5.26437 3.86886 4.48145 4.82971 4.48145ZM11.5123 7.68457C11.5732 7.68457 11.6235 7.74093 11.6237 7.80957V8.55957C11.6237 8.62832 11.5733 8.68457 11.5123 8.68457H8.61096C8.55002 8.68457 8.49963 8.62832 8.49963 8.55957V7.80957C8.49975 7.74093 8.5501 7.68457 8.61096 7.68457H11.5123ZM4.82776 5.41895C4.3827 5.41914 4.02028 5.78324 4.02014 6.23145C4.02014 6.67976 4.38261 7.04375 4.82776 7.04395C5.27307 7.04395 5.63635 6.67988 5.63635 6.23145C5.63622 5.78312 5.27299 5.41895 4.82776 5.41895ZM10.4645 5.43457C10.4846 5.43532 10.4996 5.49139 10.4996 5.55957V6.30957C10.4996 6.37784 10.4846 6.43379 10.4645 6.43457H8.53577C8.51554 6.43425 8.49963 6.37813 8.49963 6.30957V5.55957C8.49967 5.49112 8.51556 5.43487 8.53577 5.43457H10.4645Z"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2002_5758">
          <rect width="14" height="14" fill="currentColor" />
        </clipPath>
        <clipPath id="clip1_2002_5758">
          <rect width="14" height="14" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
